module.exports = {
  lang: "简体中文",
  Home: "首页",
  Index: "指数",
  Rank: "排行榜",
  Slot: "插槽",
  SubmitProject: "提交项目",
  All: "全部",
  Login: "登录",
  Logout: "退出",
  Details: "查看详情",
  NoInformation: "暂无数据",
  ViewAll: "查看全部",
  Project: "项目",
  DevelopmentActivity: "开发活跃<br>度",
  ActivityCurve: "活跃度曲线",
  Token: "代币",
  PriceChange: "价格/24h <br> 变化",
  Last7Days: "7天价格曲线",
  UnderlyingTokens:"代币",
  QuantityPerSet:"每个 Set 的数量",
  TokenPrice:"代币价格",
  CurrentPriceAllocation:"当前价格分配",
  PercentChange:"价格变化",
  TotalPricePerSet: "每个 Set 的总价",
  About: "关于",
  IndexAboutInfo: "KusamaProject 指数是一种资本化加权指数，可跟踪去中心化金融资产在整个市场中的表现。",
  Back: "返回",
  Voters: "点赞",
  event: "事件",
  VisitWebsite: "查看项目网站",
  Share: "分享",
  ParentChain: "父类",
  SubProjects: "子项目",
  SubscribeToUpdates: "订阅更新",
  YourEmail: "输入邮箱",
  Subscribe: "订阅",
  SubmitThisProject: "提交有关此项目的更新",
  projectAboutInfo:"本网站上的所有信息纯粹是教育性的，仅应用于展示您的个人研究结果。 我们不提供投资建议，任何项目或方法的认可或任何结果的承诺。",
  D:"1 天",
  W:"1 周",
  M:"1 月",
  Y:"1 年",
  Search:"搜索",
  NoResultsFound: "找不到与 w% 相关的结果",
  NoResultsInfo: "建议: <br>请确保所有字词拼写正确。<br> 尝试使用其他关键字。<br>尝试使用更宽泛的关键字。",
  NoMore: "暂无更多",
  Title:"标题",
  ProjectTitle: "项目标题",
  Category:"类别",
  SelectCategory: "选择类别",
  ShortIntroduction:"简介",
  ShortIntroductionLimit: "简介 (最多256个字符)",
  DetailDescription: "详细说明",
  Website: "网站链接",
  Email: "邮箱",
  PLOTokenAllocationPlan:"PLO 代币分配计划官方公告链接",
  Submit: "提交",
  EnterTitle:"请输入项目标题",
  EnterCategory:"请选择项目类别",
  EnterShortIntroduction:"请输入简介",
  EnterIntroductionLimited:"简介不能超过256字符",
  SubmitSuccess:"提交成功",
  ERROR:"提交失败",
  noMathExtension: "请先连接麦子钱包扩展程序",
  noAddress: "请切换到 Polkadot 钱包操作",
  noAccount: "暂无账户",
  SelectAccount: "选择账户",
  LogInMathWallet: "通过 MathWallet 登录",
  LogInPolkadotJS: "通过 PolkadotJS 登录",
  SelectLoginAccount: "选择一个插件钱包登录",
  CopySuccess: "复制成功",
  CopyFail: "请手动复制",
  GetMore: "更多",
  Fold: "收起",
  LatestProjects: "最新项目",
  AuctionCrowdloan: "竞拍 & 众贷 ",
  Join: "参与",
  LikeFailed: "操作失败",
};
